import Alpine from '@alpinejs/csp';
import {ChatApi} from "classes/chat/chatApi";
import {ChatWidget} from "classes/chat/chatWidget";

(window as any).ChatApi = ChatApi;
customElements.define('chat-widget', ChatWidget);

window.Alpine = Alpine;
Alpine.start();